// extracted by mini-css-extract-plugin
export default {"scrollBar":"ScrollBar_scrollBar__uxEF2","filler":"ScrollBar_filler__QXj4M","dotted":"ScrollBar_dotted__J8Bzn"};